import { CommonModule, NgClass, NgIf } from '@angular/common';
import { Component, Input, NgModule, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'fds-compact-vertical-tracker',
    templateUrl: './compact-vertical-tracker.component.html',
    styleUrls: ['./compact-vertical-tracker.component.scss'],
    standalone: true,
    imports: [NgClass, NgIf],
    encapsulation: ViewEncapsulation.None
})
export class CompactVerticalTrackerComponent {
  @Input() completed = false;

  @Input() disabled = false;

  @Input() active = true;

  @Input() inProgress = false;

  @Input() firstItem = false;

  @Input() simple = false;

  @Input() label = '';
}

@NgModule({
    imports: [CommonModule, FormsModule, CompactVerticalTrackerComponent],
    exports: [CompactVerticalTrackerComponent, FormsModule],
    providers: []
})
export class CompactVerticalTrakcerModule {}
